// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputOTP_wrapper__3MXvX","item":"InputOTP_item__4mxcB"};